import React from "react";

const IAToggleButton = ({ active, onToggle }) => (
    <div className="flex items-center gap-2 bg-gray-100 rounded-lg p-1">
        <button
            onClick={() => active && onToggle()}
            className={`px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${!active ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-700'}`}
        >
            Estimación estándar
        </button>
        <button
            onClick={() => !active && onToggle()}
            className={`px-3 py-1.5 rounded-md text-sm font-medium transition-colors flex items-center gap-1.5 ${active ? 'bg-white text-blue-700 shadow-sm' : 'text-gray-500 hover:text-gray-700'}`}
        >
            <span>Ajustada con IA</span>
            {active && <span className="w-1.5 h-1.5 rounded-full bg-blue-500 inline-block" />}
        </button>
    </div>
);

export default IAToggleButton;
